module.exports = __webpack_public_path__ + "static/media/teste.7230da20.m4a";